import script from "./selectOption.vue?vue&type=script&setup=true&lang=js"
export * from "./selectOption.vue?vue&type=script&setup=true&lang=js"

import "./selectOption.vue?vue&type=style&index=0&id=1fc08866&scoped=true&lang=css"

import exportComponent from "/home/forge/konfigurator.loewe-zaun.de/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fc08866"]])

export default __exports__